module.exports = __webpack_public_path__ + "img/25.82cbd257.jpg";